/**
 * Application entry point: build the store, register screens, and render.
 */

import "./ui/styles.css";
import { Store, defaultState } from "./app/state";
import { Router } from "./app/router";
import { homeScreen } from "./app/screens/home";
import { learnScreen } from "./app/screens/learn";
import { practiceScreen } from "./app/screens/practice";
import { quizScreen } from "./app/screens/quiz";
import { progressScreen } from "./app/screens/progress";
import { initProgressRepository } from "./progress/repository";
import { setProgressRecorder } from "./progress/record";

const root = document.querySelector<HTMLDivElement>("#app");
if (!root) throw new Error("missing #app root element");

const progress = initProgressRepository();
setProgressRecorder(progress);

const store = new Store(defaultState());
const router = new Router(root, store, {
  home: homeScreen,
  learn: learnScreen,
  practice: practiceScreen,
  quiz: quizScreen,
  progress: progressScreen,
});

router.render();
